import type { dash_feed } from "@dropbox/api-v2-client";
import { Menu } from "@dropbox/dig-components/menu";
import { UIIcon } from "@dropbox/dig-icons";
import { FolderLine } from "@dropbox/dig-icons/assets";
import { useFeatureFlagValueBool } from "@mirage/service-experimentation/useFeatureFlagValue";
import { openURL } from "@mirage/service-platform-actions";
import i18n from "@mirage/translations";
import { useCallback, useMemo } from "react";

export const getParentUrl = (
  activity: dash_feed.ActivityObject | undefined,
): string | undefined => {
  const objectDetails = activity?.details?.object_details;

  if (objectDetails?.[".tag"] === "document") {
    return objectDetails.parent?.url;
  }

  return undefined;
};

export const useGoToFolder = (
  parentUrl: string | undefined,
  menuItemValue: string,
): {
  goToFolder: () => void;
  goToFolderElement: JSX.Element | null;
} => {
  const isEnabled = useFeatureFlagValueBool(
    "dash_2025_08_08_go_to_folder_enabled",
  );

  const goToFolder = useCallback(() => {
    if (parentUrl) {
      openURL(parentUrl);
    }
  }, [parentUrl]);

  const goToFolderElement = useMemo(() => {
    if (!parentUrl || !isEnabled) {
      return null;
    }

    return (
      <Menu.ActionItem
        value={menuItemValue}
        withTitle={i18n.t("go_to_folder")}
        withLeftAccessory={<UIIcon src={FolderLine} />}
        onClick={goToFolder}
      />
    );
  }, [menuItemValue, goToFolder, parentUrl, isEnabled]);

  return {
    goToFolder,
    goToFolderElement,
  };
};
